// extracted by mini-css-extract-plugin
module.exports = {"outer":"_3G3M9","techinicianTextContainer":"_3aLhq","mediaContainer":"_2qL-4","textContent":"_1R3VF","name":"-kMmI","title":"_1F0a4","description":"_1AP0v"};